import { Box } from '@chakra-ui/react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import React, { useState, useEffect } from 'react';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ arrayStatusPedidos }) => {

    const data = {
        labels: ['Confirmadas', 'Para Enviar', 'Em Trânsito', 'Concluídas', 'Canceladas'],
        datasets: [
            {
                label: 'Status das Vendas',
                data: arrayStatusPedidos,
                backgroundColor: ['#4A5568', '#FEEBC8', '#4299E1', '#48BB78', '#F56565'],
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
            tooltip: {
                enabled: true,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Status das vendas',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Quantidade',
                },
                beginAtZero: true,
            },
        },
    };

    return (
        <Box py={10} bg="white" w="100%" h={{ base: "100%", md: "400px", lg: "400px" }} display="flex" justifyContent="center" alignItems="center">
            {data && <Bar data={data} options={options} />}
        </Box>
    );
};

export default BarChart;
